function env(name: string): string | undefined {
  const value = process.env[name];
  return value && value.trim() !== "" ? value : undefined;
}

export const URLS = {
  privacyPolicy:
    env("REACT_APP_PRIVACY_POLICY_URL") ??
    "https://www.ostgotatrafiken.se/kontakt-och-hjalp/villkor-och-regler/villkor-nar-du-reser-med-oss/hantering-av-personuppgifter",
  healthInformation: "https://www.1177.se/",
  sickTravelToRegion:
    "https://www.ostgotatrafiken.se/sa-reser-du-med-oss/bestallningstrafik/fardtjanst--sjukresor/sjukresor-till-annan-region/",
};
